"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var tslib_1 = require("tslib");
var Footer_1 = require("@reactionable/core/lib/ui/layout/footer/Footer");
var react_1 = tslib_1.__importDefault(require("react"));
var Col_1 = tslib_1.__importDefault(require("react-bootstrap/Col"));
var Container_1 = tslib_1.__importDefault(require("react-bootstrap/Container"));
var Row_1 = tslib_1.__importDefault(require("react-bootstrap/Row"));
var react_i18next_1 = require("react-i18next");
function Footer(_a) {
    var brand = _a.brand, _b = _a.sponsor, sponsor = _b === void 0 ? true : _b, footerProps = tslib_1.__rest(_a, ["brand", "sponsor"]);
    var t = react_i18next_1.useTranslation().t;
    var currentYear = new Date().getFullYear();
    footerProps.style = tslib_1.__assign({ position: 'absolute', bottom: 0, width: '100%', height: '60px', lineHeight: '60px' }, footerProps.style);
    return (react_1.default.createElement("footer", tslib_1.__assign({}, footerProps),
        react_1.default.createElement(Container_1.default, null,
            react_1.default.createElement(Row_1.default, { className: "justify-content-between" },
                react_1.default.createElement(Col_1.default, null,
                    t('Copyright'),
                    " \u00A9 ",
                    currentYear,
                    " ",
                    brand),
                sponsor && (react_1.default.createElement(Col_1.default, { className: "text-right" },
                    react_1.default.createElement(Footer_1.SponsorFooter, null)))))));
}
exports.Footer = Footer;
//# sourceMappingURL=Footer.js.map